export default function outils_formation() {
    let outils_formation =
        <>
            <h4>Nos outils</h4>
            <p>Entrevues d’experts | Production vidéo | Modélisation 3D<br />
                Motion capture | Réalité augmentée | Ludification<br />
                Intégration sur <em>Articulate Storyline</em><br />
                Diffusion sur votre plateforme d’apprentissage (LMS)
            </p>
        </>

        return outils_formation;
}